import React from 'react';

export default class TicketStub extends React.Component {
  static propTypes = {
    children: React.PropTypes.node,
    onClick: React.PropTypes.func,
    dataComponent: React.PropTypes.string
  };

  render () {
    return (
      <div
        role="button"
        tabIndex="0"
        className="ticket_stub"
        onClick={this.props.onClick}
        data-component={this.props.dataComponent} >
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/index.js